export { default as ic_error } from "./ic_error.svg?react";
